import { IFormDataInput } from '../model/IFormDataInput'

export const isDropDownListItemsEmpty = (
    inputName: string,
    childPlanFormDataInput: IFormDataInput[]
) => {
    const dataInput = childPlanFormDataInput.find((x) => x.Name === inputName)

    if (dataInput !== null && dataInput?.ListItems) {
        if (
            dataInput?.ListItems.length > 0 &&
            dataInput?.ListItems[0].id === ''
        ) {
            return true
        }
    }

    return false
}
